import React, {useState} from 'react';
import {Form, Col, Button, Alert} from 'react-bootstrap';
import {useFormik} from 'formik';
import * as yup from 'yup';
import micro_reporter_api from '../../apis/micro-reporter-api';
import '../../styles/css/UserList.css';
import Utils from "../../libraries/utils";

const UserForm = (props) => {

    const [showUsernameErrorMessage, setShowUsernameErrorMessage] = useState(false);
    const [showMailErrorMessage, setShowMailErrorMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let usernameErrorMessage = "This username is already in use!"
    let mailErrorMessage = "This e-mail is already in use!";
    let errorMessage = "An unexpected error was encountered!";

    var initialValues = { name: "", surname: "", username: "", password: "", email: "", role: "USER" };
    var isAdmin = false;

    const setInitialValues = () => {
        if(props.user !== undefined){
            initialValues['name'] = props.user.name;
            initialValues['surname'] = props.user.surname;
            initialValues['username'] = props.user.username;
            initialValues['email'] = props.user.email;
            initialValues['role'] = props.user.role;
            if(props.user.role === "ADMIN"){
                isAdmin = true;
            }
        }
    };

    setInitialValues();

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: yup.object({
            name: yup.string().required('Name can not be blank.'),
            surname: yup.string().required('Surname can not be blank.'),
            username: yup.string().required('Username can not be blank.'),
            email: yup.string().required('Email can not be blank.'),
        }),
        onSubmit: values => {
            values["status"] = true;
            if(document.getElementById("isAdminCheck").checked){
                values.role = "ADMIN";
            }else{
                values.role = "USER";
            }
            if(props.user !== undefined){
                values["id"] = props.user.id;
                values["keycloakId"] = props.user.keycloakId;
                updateUser(values);
            }else{
                saveUser(values);
            }
          },
    });

    const trimValues = (values) => {
        let temp = values;
        for (const [key, value] of Object.entries(temp)) {
            try{
                temp[key] = value.trim();
            }catch (e) {
                temp[key] = value
            }
        }
        return temp;
    };

    const saveUser = (values) =>{
        values = trimValues(values);
        (async () => {
            try{
                Utils.loadingScreen("show");
                let user = JSON.parse(localStorage.getItem("user"));
                let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(values.username)};
                const config = {headers};
                await micro_reporter_api.post('/micro-reporter/user/save', values, config).then(
                    () => {
                        window.location.reload();
                        Utils.loadingScreen("hide");
                    }
                );
            }catch (err){
                Utils.loadingScreen("hide");
                try{
                    showFailMessages(err.response);
                }catch{
                    showError();
                }
            }

        })();
    };

    const updateUser = (values) => {
        values = trimValues(values);
        (async () => {
            try{
                Utils.loadingScreen("show");
                let user = JSON.parse(localStorage.getItem("user"));
                let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(initialValues.username), "relatedId":values.id };
                const config = {headers};
                await micro_reporter_api.post('/micro-reporter/user/update', values, config);
                window.location.reload();
                Utils.loadingScreen("hide");
            }catch (err){
                Utils.loadingScreen("hide");
                try{
                    showFailMessages(err.response);
                }catch{
                    showError();
                }
            }

        })();
    };

    const showFailMessages = (response) => {
        switch(response.status) {
            case 400:
                showUsernameError();
                break;
            case 406:
                showEmailError();
                break;
            default:
                showError();
          }
    };

    const showUsernameError = () => {
        setShowUsernameErrorMessage(true);
        setShowMailErrorMessage(false);
        setShowErrorMessage(false);
    }

    const showEmailError = () => {
        setShowMailErrorMessage(true);
        setShowUsernameErrorMessage(false);
        setShowErrorMessage(false);
    }

    const showError = () => {
        setShowErrorMessage(true);
        setShowUsernameErrorMessage(false);
        setShowMailErrorMessage(false);
    }

    return(
        <div className="container">
            <div>
                <div id="user-list-center-div">
                    {showErrorMessage ?
                        (
                            <Alert variant="danger">
                                {errorMessage}
                            </Alert>
                        ) : null
                    }
                    <Form noValidate onSubmit={formik.handleSubmit} id="user-list">
                        <Form.Row>
                            <Form.Group as={Col} md="6" controlId="validationFormik01">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                type="text"
                                name="name"
                                placeholder=""
                                onChange={formik.handleChange}
                                value={formik.values.name}
                                onBlur={formik.handleBlur}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.name}</div>
                                ) : null}
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationFormik02">
                                <Form.Label>Surname</Form.Label>
                                <Form.Control
                                type="text"
                                name="surname"
                                onChange={formik.handleChange}
                                value={formik.values.surname}
                                onBlur={formik.handleBlur}
                                />
                                {formik.touched.surname && formik.errors.surname ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.surname}</div>
                                ) : null}
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="6" controlId="validationFormik06">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                type="text"
                                name="username"
                                disabled={formik.values.username !== undefined ? true : false}
                                onChange={formik.handleChange}
                                value={formik.values.username}
                                onBlur={formik.handleBlur}
                                />
                                {formik.touched.username && formik.errors.username ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.username}</div>
                                ) : null}
                                {showUsernameErrorMessage ?
                                    (
                                        <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{usernameErrorMessage}</div>
                                    ) : null
                                }
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationFormik03">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type="text"
                                name="email"
                                disabled={formik.values.email !== undefined ? true : false}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.email && formik.errors.email ? (
                                <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.email}</div>
                              ) : null}
                              {showMailErrorMessage ?
                                (
                                  <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{mailErrorMessage}</div>
                                ) : null
                              }
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                        <Form.Group id="formGridCheckbox" style={{paddingLeft: "5px"}}>
                            <Form.Check
                                type="checkbox"
                                id="isAdminCheck"
                                label="is Admin"
                                defaultChecked={isAdmin}
                                custom
                            />
                        </Form.Group>
                        </Form.Row>
                        <Button type="submit" block>
                            Save
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default UserForm;
